// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/organizations/firstparty/v5/get_organization.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Enum for organization status. */
export const ApiOrganizationStatus = {
  /** ORGANIZATION_STATUS_UNSPECIFIED - Unspecified status. */
  ORGANIZATION_STATUS_UNSPECIFIED: "ORGANIZATION_STATUS_UNSPECIFIED",
  /**
   * activated - Organization is activated.
   */
  activated: "activated",
  /**
   * deactivated - Organization is deactivated.
   */
  deactivated: "deactivated",
  /**
   * kyb_waiting - Organization is waiting for KYB.
   */
  kyb_waiting: "kyb_waiting",
  /**
   * suspended - Organization is suspended.
   */
  suspended: "suspended",
} as const;

export type ApiOrganizationStatus = typeof ApiOrganizationStatus[keyof typeof ApiOrganizationStatus];

export namespace ApiOrganizationStatus {
  export type ORGANIZATION_STATUS_UNSPECIFIED = typeof ApiOrganizationStatus.ORGANIZATION_STATUS_UNSPECIFIED;
  export type activated = typeof ApiOrganizationStatus.activated;
  export type deactivated = typeof ApiOrganizationStatus.deactivated;
  export type kyb_waiting = typeof ApiOrganizationStatus.kyb_waiting;
  export type suspended = typeof ApiOrganizationStatus.suspended;
}

export function apiOrganizationStatusFromJSON(object: any): ApiOrganizationStatus {
  switch (object) {
    case 0:
    case "ORGANIZATION_STATUS_UNSPECIFIED":
      return ApiOrganizationStatus.ORGANIZATION_STATUS_UNSPECIFIED;
    case 1:
    case "activated":
      return ApiOrganizationStatus.activated;
    case 2:
    case "deactivated":
      return ApiOrganizationStatus.deactivated;
    case 3:
    case "kyb_waiting":
      return ApiOrganizationStatus.kyb_waiting;
    case 4:
    case "suspended":
      return ApiOrganizationStatus.suspended;
    default:
      return ApiOrganizationStatus.ORGANIZATION_STATUS_UNSPECIFIED;
  }
}

export function apiOrganizationStatusToJSON(object: ApiOrganizationStatus): string {
  switch (object) {
    case ApiOrganizationStatus.ORGANIZATION_STATUS_UNSPECIFIED:
      return "ORGANIZATION_STATUS_UNSPECIFIED";
    case ApiOrganizationStatus.activated:
      return "activated";
    case ApiOrganizationStatus.deactivated:
      return "deactivated";
    case ApiOrganizationStatus.kyb_waiting:
      return "kyb_waiting";
    case ApiOrganizationStatus.suspended:
      return "suspended";
    default:
      return "ORGANIZATION_STATUS_UNSPECIFIED";
  }
}

/** Enum for suspension reason. */
export const ApiSuspensionReason = {
  /** SUSPENSION_REASON_UNSPECIFIED - Unspecified suspension reason */
  SUSPENSION_REASON_UNSPECIFIED: "SUSPENSION_REASON_UNSPECIFIED",
  /**
   * manual_suspension - Manual suspension
   */
  manual_suspension: "manual_suspension",
  /**
   * seizure - Seizure
   */
  seizure: "seizure",
  /**
   * flex_kyb_grace_period_expired - Flex KYB grace period expired
   */
  flex_kyb_grace_period_expired: "flex_kyb_grace_period_expired",
  /**
   * expired_due_diligence - Expired due diligence
   */
  expired_due_diligence: "expired_due_diligence",
  /**
   * expired_poi - Expired POI
   */
  expired_poi: "expired_poi",
  /**
   * dormant_account - Dormant account
   */
  dormant_account: "dormant_account",
  /**
   * bafin - BaFin regulatory suspension
   */
  bafin: "bafin",
  /**
   * re_kyc - Re-KYC required
   */
  re_kyc: "re_kyc",
  /**
   * afc_asset_freeze - AFC asset freeze
   */
  afc_asset_freeze: "afc_asset_freeze",
  /**
   * deactivation_postponement - Deactivation postponement
   */
  deactivation_postponement: "deactivation_postponement",
} as const;

export type ApiSuspensionReason = typeof ApiSuspensionReason[keyof typeof ApiSuspensionReason];

export namespace ApiSuspensionReason {
  export type SUSPENSION_REASON_UNSPECIFIED = typeof ApiSuspensionReason.SUSPENSION_REASON_UNSPECIFIED;
  export type manual_suspension = typeof ApiSuspensionReason.manual_suspension;
  export type seizure = typeof ApiSuspensionReason.seizure;
  export type flex_kyb_grace_period_expired = typeof ApiSuspensionReason.flex_kyb_grace_period_expired;
  export type expired_due_diligence = typeof ApiSuspensionReason.expired_due_diligence;
  export type expired_poi = typeof ApiSuspensionReason.expired_poi;
  export type dormant_account = typeof ApiSuspensionReason.dormant_account;
  export type bafin = typeof ApiSuspensionReason.bafin;
  export type re_kyc = typeof ApiSuspensionReason.re_kyc;
  export type afc_asset_freeze = typeof ApiSuspensionReason.afc_asset_freeze;
  export type deactivation_postponement = typeof ApiSuspensionReason.deactivation_postponement;
}

export function apiSuspensionReasonFromJSON(object: any): ApiSuspensionReason {
  switch (object) {
    case 0:
    case "SUSPENSION_REASON_UNSPECIFIED":
      return ApiSuspensionReason.SUSPENSION_REASON_UNSPECIFIED;
    case 1:
    case "manual_suspension":
      return ApiSuspensionReason.manual_suspension;
    case 2:
    case "seizure":
      return ApiSuspensionReason.seizure;
    case 3:
    case "flex_kyb_grace_period_expired":
      return ApiSuspensionReason.flex_kyb_grace_period_expired;
    case 4:
    case "expired_due_diligence":
      return ApiSuspensionReason.expired_due_diligence;
    case 5:
    case "expired_poi":
      return ApiSuspensionReason.expired_poi;
    case 6:
    case "dormant_account":
      return ApiSuspensionReason.dormant_account;
    case 7:
    case "bafin":
      return ApiSuspensionReason.bafin;
    case 8:
    case "re_kyc":
      return ApiSuspensionReason.re_kyc;
    case 9:
    case "afc_asset_freeze":
      return ApiSuspensionReason.afc_asset_freeze;
    case 10:
    case "deactivation_postponement":
      return ApiSuspensionReason.deactivation_postponement;
    default:
      return ApiSuspensionReason.SUSPENSION_REASON_UNSPECIFIED;
  }
}

export function apiSuspensionReasonToJSON(object: ApiSuspensionReason): string {
  switch (object) {
    case ApiSuspensionReason.SUSPENSION_REASON_UNSPECIFIED:
      return "SUSPENSION_REASON_UNSPECIFIED";
    case ApiSuspensionReason.manual_suspension:
      return "manual_suspension";
    case ApiSuspensionReason.seizure:
      return "seizure";
    case ApiSuspensionReason.flex_kyb_grace_period_expired:
      return "flex_kyb_grace_period_expired";
    case ApiSuspensionReason.expired_due_diligence:
      return "expired_due_diligence";
    case ApiSuspensionReason.expired_poi:
      return "expired_poi";
    case ApiSuspensionReason.dormant_account:
      return "dormant_account";
    case ApiSuspensionReason.bafin:
      return "bafin";
    case ApiSuspensionReason.re_kyc:
      return "re_kyc";
    case ApiSuspensionReason.afc_asset_freeze:
      return "afc_asset_freeze";
    case ApiSuspensionReason.deactivation_postponement:
      return "deactivation_postponement";
    default:
      return "SUSPENSION_REASON_UNSPECIFIED";
  }
}

/** Request for getting organization information. */
export interface ApiGetOrganizationRequest {
  /** The organization ID. */
  readonly id: string;
}

/** Organization details. */
export interface ApiOrganization {
  /** Organization ID. */
  readonly id: string;
  /** Organization name. */
  readonly name: string;
  /** Organization slug. */
  readonly slug: string;
  /** Organization status. */
  readonly status: ApiOrganizationStatus;
  /** Timestamp when the organization was created. */
  readonly createdAt:
    | Date
    | null;
  /** Timestamp when the contract was signed. */
  readonly suspensionReason?: ApiSuspensionReason | null | undefined;
}

/** Response containing organization information. */
export interface ApiGetOrganizationResponse {
  /** The organization details. */
  readonly organization: ApiOrganization | null;
}

export const ApiGetOrganizationRequest: MessageFns<ApiGetOrganizationRequest> = {
  fromJSON(object: any): ApiGetOrganizationRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetOrganizationRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiOrganization: MessageFns<ApiOrganization> = {
  fromJSON(object: any): ApiOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
      status: isSet(object.status)
        ? apiOrganizationStatusFromJSON(object.status)
        : ApiOrganizationStatus.ORGANIZATION_STATUS_UNSPECIFIED,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : null,
      suspensionReason: isSet(object.suspensionReason) ? apiSuspensionReasonFromJSON(object.suspensionReason) : null,
    };
  },

  toJSON(message: ApiOrganization): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.slug !== undefined && message.slug !== null) {
      obj.slug = message.slug;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = apiOrganizationStatusToJSON(message.status);
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.suspensionReason !== undefined && message.suspensionReason !== null) {
      obj.suspensionReason = apiSuspensionReasonToJSON(message.suspensionReason);
    }
    return obj;
  },
};

export const ApiGetOrganizationResponse: MessageFns<ApiGetOrganizationResponse> = {
  fromJSON(object: any): ApiGetOrganizationResponse {
    return { organization: isSet(object.organization) ? ApiOrganization.fromJSON(object.organization) : null };
  },

  toJSON(message: ApiGetOrganizationResponse): unknown {
    const obj: any = {};
    if (message.organization !== undefined && message.organization !== null) {
      obj.organization = ApiOrganization.toJSON(message.organization);
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
